import React from 'react';
import { Card, Table, Row, Col, Statistic } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useControlTowerDocuments } from '@/hooks/useManufacturingControlTower';

const DocumentCollectionStatus: React.FC = () => {
  const navigate = useNavigate();
  const { data, isLoading } = useControlTowerDocuments();
  const d = data as {
    pending?: Array<Record<string, unknown>>;
    missing?: Array<Record<string, unknown>>;
    pending_count?: number;
    missing_count?: number;
  };

  return (
    <Card id="documents" title="Document collection status" style={{ marginTop: 16 }}>
      <Row gutter={16} style={{ marginBottom: 12 }}>
        <Col><Statistic title="Pending" value={d?.pending_count ?? 0} /></Col>
        <Col><Statistic title="Missing checklist" value={d?.missing_count ?? 0} /></Col>
      </Row>
      <Table
        size="small"
        loading={isLoading}
        rowKey={(r) => String(r.id || r.collection_id || Math.random())}
        dataSource={d?.pending ?? []}
        onRow={(r) => ({
          onClick: () => r.id && navigate(`/growth/document-collections/${r.id}`),
          style: { cursor: r.id ? 'pointer' : 'default' },
        })}
        columns={[
          { title: 'Package', dataIndex: 'package_number' },
          { title: 'Customer', dataIndex: 'customer_name' },
          { title: 'Status', dataIndex: 'status' },
        ]}
        pagination={{ pageSize: 10 }}
      />
    </Card>
  );
};

export default DocumentCollectionStatus;
